<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hHTS53/tc-custom/9781514004685.jpg?1688600223825" alt="This image is the cover for the book Message of Ruth"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Message of Ruth
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong>The book of Ruth tells the story of ordinary people facing ordinary events.</strong> We meet Naomi, who went through famine and bereavement but eventually won peace and security. We meet Ruth, a foreign woman from Moab who chose faithfulness to her mother-in-law, Naomi, and to Naomi's God. And we meet Boaz, who by marrying Ruth fitted into God's purposes for history. Both King David and Jesus are numbered among their descendants.</p> <p>Theologically the story of Ruth is a story about God's providence, as David Atkinson demonstrates clearly in his passage-by-passage exposition. Part of the beloved Bible Speaks Today series, <em>The Message of Ruth</em> offers insightful, readable commentary on the biblical text and thought-provoking discussion of how its meaning relates to contemporary life. </p> <p>Used by students and teachers around the world, The Bible Speaks Today commentaries are ideal for those studying or preaching the Bible and anyone who wants to delve deeper into the text. This beautifully redesigned edition has also been sensitively updated with more current references and the NRSV Bible text.</p> <p>In the new New Testament volumes, the commentary on each section of the text is structured under three headings: <em>Context</em>, <em>Comment</em>, and <em>Theology</em>. The goal is to explain the true meaning of the Bible and make its message plain.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David J. Atkinson
      </h2>
      
      <p class="authorDescription body article"><p>David J. Atkinson is honorary assistant bishop in the Diocese of Southwark, and formerly Suffragan Bishop of Thetford in the Diocese of Norwich. He is also the author of the volumes on Genesis 1-11, Job, and Proverbs in the Bible Speaks Today series of commentaries.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      IVP
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3a4b71c4